// extracted by mini-css-extract-plugin
module.exports = {"content2":"DT_content2__f0Y9L","dt":"DT_dt__3ovoA","dt_font":"DT_dt_font__ytqpf","dt_zh":"DT_dt_zh__2f3oK","dt_en":"DT_dt_en__3g885","dt_chunk":"DT_dt_chunk__28WMi"};